/** Brighten a signal color until it reads clearly on every dark key/preview surface. */
export function readableCueColor(input: string): string {
  const normalized = /^#[0-9a-f]{3}$/i.test(input) ? `#${input.slice(1).split("").map(digit => digit + digit).join("")}` : input;
  const hex = /^#[0-9a-f]{6}$/i.test(normalized) ? normalized : "#ffd426";
  const rgb = [1, 3, 5].map(start => Number.parseInt(hex.slice(start, start + 2), 16));
  const luminance = (values: number[]) => values.reduce((sum, value, index) => {
    const channel = value / 255;
    return sum + (channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4) * [0.2126, 0.7152, 0.0722][index];
  }, 0);
  if (luminance(rgb) >= 0.32) return hex;
  let adjusted = rgb;
  for (let mix = 0.05; mix <= 1.001; mix += 0.05) {
    adjusted = rgb.map(channel => Math.round(channel + (255 - channel) * mix));
    if (luminance(adjusted) >= 0.32) break;
  }
  return `#${adjusted.map(channel => channel.toString(16).padStart(2, "0")).join("")}`;
}
